/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
// CONSTANTS are all caps.
const NS = 'DownloadBriefBlock';
const CLS = 'downloadBriefBlock';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/downloadBriefBlock.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class DownloadBriefBlock {
	constructor($el) {
		// $el is the widget node return by the loadDownloadBriefBlock function
		this.$el = $el;
	}

	init() {
		this.setDownloadBriefBlock();
	}

	setDownloadBriefBlock() {
		// Add Some logic here
		const $wg = $(this.$el);

		$wg.on('click', `${WG}btn`, function() {
			let selectedFileLink = $wg.find(`${WG}select`).val();
			if (selectedFileLink && selectedFileLink != '') {
				window.open(selectedFileLink);
			}
		});
	}

	// Add more functions like on above here
}
